// extracted by mini-css-extract-plugin
module.exports = {"scorecards":"style_scorecards__wvheS","scoreHead":"style_scoreHead__y3jKD"};